export enum TypeLigne {
  ARTICLE        = 'ARTICLE',
  REMISE         = 'REMISE',
  CHARGE         = 'CHARGE',
  COMMENTAIRE    = 'COMMENTAIRE',
  COMPOSANT      = 'COMPOSANT',     // Ligne auto-générée par NomenclatureService.buildComponentLines
  IMMOBILISATION = 'IMMOBILISATION', // Spawn une entrée dans la table immobilisation via hook
  TRANSFERT      = 'TRANSFERT',     // Ligne auto-générée (sortie dépôt source) sur un doc de transfert interne
  AJUSTEMENT     = 'AJUSTEMENT',    // Ligne auto-générée (écart de comptage) sur un doc d'inventaire
}

export enum MethodeAmortissement {
  LINEAIRE = 'LINEAIRE',
}

export enum TypeTiers {
    CLIENT = 'client',
    FOURNISSEUR = 'fournisseur',
    AUCCUN = 'aucun',
    EMPLOYE = 'employe',
  }

  export enum TypeReglement {
    ENCAISSEMENT = 'ENCAISSEMENT',
    PAIEMENT = 'PAIEMENT',
    MOUVEMENT = 'MOUVEMENT',
    // Opération diverse : écriture sur un compte tiers SANS impact caisse. Voir migration 0079.
    OPERATION_DIVERSE = 'OPERATION_DIVERSE',
  }
  
  
  export enum ButtonColor {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    SUCCESS = "success",
    ERROR = "error",
    INFO = "info",
    WARNING = "warning",
  }

  export enum ButtonType {
    EDIT = "edit",
    INSERT = "insert",
    DELETE = "delete",
    PRINT = "print",
    DOWNLOAD = "download",
    CANCEL = "cancel",
    VIEW = "view",
    DEFAULT = "default",
  }
  export enum CompteTypeOperation {
    DOCUMENT_VENTE = 'DOCUMENT_VENTE',
    REGLEMENT = 'REGLEMENT',
}
  
export enum GeneriqueDataType {
    DEPOT ="DEPOT",
    CAISSE="CAISSE",
    MODE_REGLEMENT="MODE_REGLEMENT",
    NATURE_REGLEMENT="NATURE_REGLEMENT",
    NATURE_TACHE="NATURE_TACHE",
    FAMILLE_ARTICLE="FAMILLE_ARTICLE",
    CATEGORIE_NATURE_REGLEMENT="CATEGORIE_NATURE_REGLEMENT",
    CATEGORIE_CLIENT="CATEGORIE_CLIENT",
    CATEGORIE_FOURNISSEUR="CATEGORIE_FOURNISSEUR",
    WORKFLOW="WORKFLOW",
}

/**
 * Portée d'un type de generique_data (miroir de agence_api/src/models/Enums.ts).
 *  - GLOBAL      : entité commune à tous les départements (departement_id NULL).
 *  - DEPARTEMENT : entité rattachable au département actif (CAISSE, DEPOT).
 */
export enum PorteeGenerique {
  GLOBAL      = "GLOBAL",
  DEPARTEMENT = "DEPARTEMENT",
}

/** Impact d'une catégorie de nature de règlement dans le compte de résultat. */
export enum ImpactResultat {
  PRODUIT = "PRODUIT", // revenu  → augmente le bénéfice
  CHARGE  = "CHARGE",  // dépense → diminue le bénéfice
  NEUTRE  = "NEUTRE",  // mouvement de trésorerie → exclu du calcul
}

/**
 * Registre des types catégorisables : type "feuille" → son type "catégorie".
 * Miroir de agence_api/src/models/Enums.ts. Ajouter une entrée ici rend un
 * type catégorisable (formulaire GeneriqueDataForm + SelectCategorie).
 */
export const CATEGORISABLE_TYPES: Partial<Record<GeneriqueDataType, GeneriqueDataType>> = {
  [GeneriqueDataType.NATURE_REGLEMENT]: GeneriqueDataType.CATEGORIE_NATURE_REGLEMENT,
};

/**
 * Reverse de CATEGORISABLE_TYPES : type "catégorie" → type "feuille" qu'il catégorise.
 * Renvoie undefined si le type passé n'est pas un type catégorie.
 * Sert à savoir si un type est hiérarchique (= type catégorie) et quelles entités
 * lui sont rattachées.
 */
export const leafTypeOfCategory = (categoryType: GeneriqueDataType): GeneriqueDataType | undefined =>
  (Object.keys(CATEGORISABLE_TYPES) as GeneriqueDataType[])
    .find((leaf) => CATEGORISABLE_TYPES[leaf] === categoryType);

export enum PermissionModule {
  ARTICLES     = 'articles',
  TIERS        = 'tiers',
  BIENS        = 'biens',
  CONTRATS     = 'contrats',
  REGLEMENTS   = 'reglements',
  COMPTES      = 'comptes',
  STOCK        = 'stock',
  FAMILLES     = 'familles',
  DEPARTEMENTS = 'departements',
  TACHES       = 'taches',
  USERS        = 'users',
  ROLES        = 'roles',
  DOC_VENTES   = 'docVentes',
  NOTIFICATIONS = 'notifications',
  IMMOBILISATIONS = 'immobilisations',
}

/** Droit d'accorder une remise (remise % ligne ARTICLE, ligne REMISE) — migration 0145.
 *  Miroir de PERMISSION_REMISE côté API (LigneDocumentVentePipeline). */
export const PERMISSION_REMISE = 'docVentes.remise';
/** Droits de saisie de ligne — migration 0155. Miroirs de LigneDocumentVentePipeline (API). */
export const PERMISSION_PRIX = 'docVentes.prix';                     // modifier le prix unitaire
export const PERMISSION_VENTE_SOUS_COUT = 'docVentes.venteSousCout'; // vendre sous le prix de revient
/** Voir le prix de revient — migration 0156. Sans ce droit l'API renvoie null pour tout coût
 *  (miroir de agence_api/src/utils/masquageCout.ts) : l'écran masque les champs concernés. */
export const PERMISSION_PRIX_REVIENT = 'articles.prixRevient';

/** Droits fins sur les prix par département — migration 0154.
 *  Miroir de PERMISSION_PRIX_DEPT côté API (DepartementService). */
export const PERMISSION_PRIX_DEPT = {
  READ:   'prixDepartements.read',
  UPDATE: 'prixDepartements.update',
  DELETE: 'prixDepartements.delete',
} as const;

export enum PermissionAction {
  READ   = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum TypeRapport {
  DOCUMENT_VENTE      = 'DOCUMENT_VENTE',
  LISTE_ARTICLE       = 'LISTE_ARTICLE',
  STOCK               = 'STOCK',
  MOUVEMENT_STOCK     = 'MOUVEMENT_STOCK',
  TIERS               = 'TIERS',
  IMPRESSION_DOCUMENT = 'IMPRESSION_DOCUMENT',
  COMPTE_CLIENT       = 'COMPTE_CLIENT',
  COMPTE_FOURNISSEUR  = 'COMPTE_FOURNISSEUR',
  COMPTE_EMPLOYE      = 'COMPTE_EMPLOYE',
  COMPTE_CAISSE       = 'COMPTE_CAISSE',
  LISTE_REGLEMENT     = 'LISTE_REGLEMENT',
  BALANCE_CLIENT      = 'BALANCE_CLIENT',
  BALANCE_FOURNISSEUR = 'BALANCE_FOURNISSEUR',
  BALANCE_EMPLOYE     = 'BALANCE_EMPLOYE',
}

export enum FormatRapport {
  PDF   = 'PDF',
  EXCEL = 'EXCEL',
}

export enum StatutJob {
  PENDING    = 'PENDING',
  PROCESSING = 'PROCESSING',
  DONE       = 'DONE',
  ERROR      = 'ERROR',
}

export enum WorkflowStatutTrigger {
  DISPATCH_PARTIEL  = 'DISPATCH_PARTIEL',
  DISPATCH_COMPLET  = 'DISPATCH_COMPLET',
  DOC_FINAL_CREE    = 'DOC_FINAL_CREE',
  PAIEMENT_PARTIEL  = 'PAIEMENT_PARTIEL',   // Phase 2
  PAIEMENT_COMPLET  = 'PAIEMENT_COMPLET',   // Phase 2
}

export enum NotificationSource {
  SYSTEM   = 'SYSTEM',
  ADMIN    = 'ADMIN',
  WORKFLOW = 'WORKFLOW',
}

export enum NotificationNiveau {
  INFO    = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR   = 'ERROR',
}

export enum OptionType {
  BOOLEAN = 'BOOLEAN',
  STRING  = 'STRING',
  NUMBER  = 'NUMBER',
  JSON    = 'JSON',
}

export enum OptionCategory {
  STOCK       = 'STOCK',
  POS         = 'POS',
  FACTURATION = 'FACTURATION',
  GENERAL     = 'GENERAL',
}

export enum ScopeType {
  DEPARTEMENT         = 'DEPARTEMENT',
  DEPOT               = 'DEPOT',
  CAISSE              = 'CAISSE',
  TYPE_DOCUMENT       = 'TYPE_DOCUMENT',
  RESTRICT_TO_CREATOR = 'RESTRICT_TO_CREATOR',
}

export enum ScopeEffect {
  BLOCK = 'BLOCK',
  ALLOW = 'ALLOW',
}

/**
 * Catalogue des clés d'options utilisables en code — miroir de `sys_option_definition`.
 * À tenir synchronisé avec les migrations seed.
 * Usage : useOption<boolean>(OptionKey.POS_AUTO_PRINT, true)
 */
export enum OptionKey {
  STOCK_ALLOW_NEGATIVE       = 'stock.allow_negative',
  STOCK_ALERT_STOCK_SECURITE = 'stock.alert_stock_securite',
  STOCK_BLOQUER_AVANT_INVENTAIRE = 'stock.bloquer_avant_inventaire', // tenant — interdit un mouvement antérieur à un inventaire (article compté)
  POS_AUTO_PRINT             = 'pos.auto_print',
  POS_SHOW_SCANNER_INPUT     = 'pos.show_scanner_input',
  POS_TICKET_HEADER_TEXT     = 'pos.ticket_header_text',
  FACTURATION_TVA_DEFAULT    = 'facturation.tva_default',
  // CMUP — recalcul automatique du prix de revient à la réception d'achat
  CMUP_DEPT_ENABLED          = 'cmup.dept_enabled',
  CMUP_GLOBAL_ENABLED        = 'cmup.global_enabled',
  // TIERS — plafonnement des comptes
  TIERS_CHECK_PLAFOND_DEPT   = 'tiers.check_plafond_dept',
  TIERS_CHECK_PLAFOND_GLOBAL = 'tiers.check_plafond_global',
  TIERS_PLAFOND_INCLURE_ENCOURS = 'tiers.plafond_inclure_encours',   // BL / BRF non facturés comptés dans le plafond
  // ARTICLE — création depuis un département : PV / PR saisis réservés à ce département (0138)
  ARTICLE_PRIX_CREATION_DEPT = 'article.prix_creation_dept',
}

// ── Actions de masse par famille (migration 0134) — miroir agence_api/src/models/Enums.ts ──
/** Niveau de prix modifié : défaut tenant (article) ou override département. */
export enum NiveauPrix {
  DEFAUT      = 'DEFAUT',
  DEPARTEMENT = 'DEPARTEMENT',
}

/** Champ de prix ajusté. */
export enum ChampPrix {
  PRIX_V = 'PRIX_V',
  PRIX_R = 'PRIX_R',
  REMISE = 'REMISE',
}

/** Mode d'ajustement : ± pourcentage, ± montant, ou valeur fixe. */
export enum ModeAjustement {
  POURCENT = 'POURCENT',
  MONTANT  = 'MONTANT',
  FIXE     = 'FIXE',
}

/** Modification du partage par département (lot 2, migration 0135). */
export enum ModePartage {
  AJOUTER   = 'AJOUTER',     // ajoute des départements au partage actuel
  RETIRER   = 'RETIRER',     // retire des départements (partagé avec tous → tous sauf ceux-là)
  REMPLACER = 'REMPLACER',   // remplace la liste
  TOUS      = 'TOUS',        // partagé avec tous (aucune restriction)
}
/** Valeurs d'une famille applicables à ses articles (lot 3, migration 0136). */
export enum ChampDefautFamille {
  PRIX_V            = 'PRIX_V',
  PRIX_R            = 'PRIX_R',
  REMISE            = 'REMISE',
  TVA               = 'TVA',
  UNITE             = 'UNITE',
  UNITE_SEC         = 'UNITE_SEC',
  PIECES_PAR_CARTON = 'PIECES_PAR_CARTON',
  TRACK_STOCK       = 'TRACK_STOCK',
  STOCK_SECURITE    = 'STOCK_SECURITE',
  PARTAGE           = 'PARTAGE',            // départements de partage par défaut
  PRIX_DEPARTEMENTS = 'PRIX_DEPARTEMENTS',  // prix par département de la famille
  FOURNISSEUR       = 'FOURNISSEUR',        // fournisseur principal par défaut (0143)
}
  